import { createAction, props } from '@ngrx/store';

export const posAssetKey = '[positionDetails]';

export const setPosition = createAction(
    `${posAssetKey} setPosition`,
    props<{ payload: any }>()
);

export const reset = createAction(`${posAssetKey} Reset`);